
import { defineComponent, onUnmounted, getCurrentInstance, onMounted, ref, computed, onActivated, nextTick, onDeactivated } from 'vue';
import Toast from 'vant/lib/toast';
import cookies from 'js-cookie';
import VideoCategoryCard from './components/video-category-card/index.vue';
import PictureCategoryCard from './components/picture-category-card/index.vue';
import UserVideoCard from './components/user-video-card/index.vue';
import GuessCard from './components/guess-card/index.vue';
import UserNicknameCard from './components/user-nickname-card/index.vue';
import SearchBar from './components/new-search/index.vue';
import PostCard from './components/new-card/index.vue';
import List from './components/list/index.vue';
import VideoCategoryCardList from './components/video-category-card-list/index.vue';
import ExpandWords from './components/expand-words/index.vue';
import { immediateSendLog, getKwaiLog, sendLog } from '@/common/radar';
import LoginPopup from '@/components/login/index.vue';
import { useLogin } from '@/hooks/useLogin';
import { commonPvParams } from '@/common/utils';

const MaxRenderTimeForFirstTime = 3000;

export default defineComponent({
    components: {
        VideoCategoryCard,
        UserVideoCard,
        GuessCard,
        UserNicknameCard,
        LoginPopup,
        SearchBar,
        PostCard,
        List,
        VideoCategoryCardList,
        PictureCategoryCard,
        ExpandWords,
    },
    props: {},
    setup(ctx, props) {
        const fmp_time = Date.now();
        const { proxy } = getCurrentInstance() as { proxy: any };
        const beginTime = ref(0);
        const muted = ref(true);
        const videoCategoryCardListRef = ref();
        const dynamicCompRef = ref([] as any);
        const searchBarRef = ref();

        const firstCardFinishLoad = ref(false);
        const expandwordsRef = ref();
        const expandwords = ref(false);

        const newDiscoverList = computed(() => {
            return proxy.$store.state.newDiscoverModule.newDiscoverList;
        });

        // 登录 hooks
        const {
            showLoginPopup: isShowLoginPopup,
            isLoginStatus,
            handleLoginPopupClose,
            changeLoginStatus,
            handleLoginPopupOpenkwai,
            changeLoginPopupShow,
        } = useLogin();

        const handleFirstCardFinishRender = (index: number) => {
            if (firstCardFinishLoad.value) {
                return;
            }
            firstCardFinishLoad.value = index === 0;
        };

        const follow = async ({ kwaiId, fType }: { kwaiId: string; fType: 0 | 1 | 2 }) => {
            const { result, errorMsg, data } = await proxy.$axios.$$post('overseaAPI::/rest/o/w/pwa/followAction', {
                fromPage: 'new_discover',
                toUid: '@' + kwaiId,
                fType: 1, //
            });

            if (result === 1) {
                // 关注已发送，对方设置了隐私保护
                if (data?.followStatus === 2) {
                    Toast({
                        message: proxy.$root.$t('k_327834'),
                    });
                }
            } else if (result === 109 || result === 1047232003) {
                isShowLoginPopup.value = true;
            } else {
                errorMsg &&
                    Toast({
                        message: errorMsg,
                    });
            }
        };

        // 统一设置整个页面video标签的静音
        const setMuted = (type: boolean) => {
            muted.value = type;
        };

        const jumpProfile = (id: number) => {
            proxy.$router.push({ path: `/@${id}`, query: { page_source: 'new_discover' } });
        };

        const initNewData = async () => {
            const res = await proxy.$store.dispatch('newDiscoverModule/getNewDiscoverList', { $axios: proxy.$axios, route: proxy.$route });
            if (res.result === 1) {
                proxy.$store.commit('newDiscoverModule/setNewDiscoverList', { data: res.data });
            }
            nextTick(() => {
                scrollAutoPlayVideos();
            });
        };

        let observer: any;
        // let lastPlayVideoEle: any

        const scrollAutoPlayVideos = () => {
            const videoElements: any = document.querySelectorAll('.video-observer');
            const userVideoCardVideoList: any = document.querySelectorAll('.uv-group');
            const viewLayoutRects: any = document.querySelector('.main')!.getClientRects();
            function handleIntersection(entries: any) {
                entries.forEach((entry: any) => {
                    const visibleVideoDom = entry.target;
                    const visibleVideoIndex = Number(visibleVideoDom.getAttribute('data-index')); // 通过index找到对应的组件
                    const userVideoCompIndex = Number(visibleVideoDom.getAttribute('data-user-video-index')); // 通过user video index找到对应的组件
                    const observeCompType = visibleVideoDom.getAttribute('data-type');
                    let visibleVideo: any = null;

                    if (observeCompType === 'video-category-card') {
                        visibleVideo =
                            dynamicCompRef.value[visibleVideoIndex]?.videoComp ||
                            videoCategoryCardListRef.value?.videoCategoryCardRefs[visibleVideoIndex]?.videoComp;
                    }

                    if (observeCompType === 'user-video-card') {
                        visibleVideo = dynamicCompRef.value[visibleVideoIndex]?.userVideoComps[0];
                    }

                    console.log('handleIntersection-->', observeCompType, visibleVideoIndex, userVideoCompIndex, visibleVideo);

                    // 在下方被遮挡
                    const isInBottom = entry.boundingClientRect.bottom - viewLayoutRects.height > 0;
                    // 如果视频进入视口
                    console.log(
                        'handleIntersection111-->',
                        visibleVideoIndex,
                        entry.isIntersecting,
                        entry.boundingClientRect.top,
                        entry.intersectionRatio,
                        isInBottom
                    );
                    if (entry.isIntersecting && entry.boundingClientRect.top > 0 && entry.intersectionRatio > 0.8 && !isInBottom) {
                        // // 暂停其他视频
                        dynamicCompRef.value.forEach((item: any) => {
                            console.log('handleIntersection forEach', item.cardType);
                            if (item?.cardType === 'user-video-card') {
                                item.userVideoComps.forEach((video: any) => {
                                    if (video !== visibleVideo) {
                                        video?.pause();
                                    }
                                });
                            }

                            if (item?.cardType === 'video-category-card' && item.videoComp !== visibleVideo) {
                                item.videoComp?.pause();
                            }
                        });
                        videoCategoryCardListRef.value?.videoCategoryCardRefs.forEach((item: any) => {
                            if (item && item.videoComp !== visibleVideo) {
                                item.videoComp?.pause();
                            }
                        });
                        // 播放当前视频
                        if (visibleVideo.getPaused()) {
                            console.log('handleIntersection visibleVideo-->', observeCompType, visibleVideoIndex, userVideoCompIndex);
                            // visibleVideo.load()
                            setTimeout(() => {
                                visibleVideo.play();
                                window.lastPlayVideoEle = visibleVideo;
                            }, 500);
                        }
                    } else {
                        console.log('handleIntersection else');
                        visibleVideo?.pause();
                    }
                });
            }

            // 设置Intersection Observer
            observer = new IntersectionObserver(handleIntersection, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });

            // 监测每个视频元素
            videoElements.forEach((video: HTMLVideoElement) => {
                observer.observe(video);
            });
        };

        const sendPv = () => {
            const params = commonPvParams({ defaultPageSource: 'search' });
            // 获取启动config
            const country = proxy.$store.state.startup.countryInfo;
            const user_id = cookies.get('user_id');
            immediateSendLog({
                type: 'pv',
                name: 'SEO_RESEARCH_RESULT_PAGE',
                value: {
                    country,
                    user_id,
                    discoverUi: proxy.$store?.state?.startup?.discoverUi,
                    search_word: searchBarRef.value?.searchText || '',
                    ...params,
                },
            });
        };

        const handleSearch = () => {
            initNewData();
            proxy.$store.dispatch('initGetDiscoverList', { $axios: proxy.$axios, route: proxy.$route });
        };

        const consume_duration = () => {
            const webLogger = getKwaiLog();
            // 停留时长
            webLogger.sendImmediately('PV', {
                type: 'leave',
                beginTime: beginTime.value,
            });
            // 每次触发离开事件 都重新计时
            beginTime.value = new Date().getTime();
        };
        // watch(() => proxy.$route.fullPath, (newValue, oldValue) => {
        //   if (newValue !== oldValue) {
        //     debugger
        //     initNewData()
        //     proxy.$store.dispatch('initGetDiscoverList', { $axios: proxy.$axios, route: proxy.$route })
        //   }
        // })
        onMounted(() => {
            setTimeout(() => {
                // 兜底，如果超过 MaxRenderTimeForFirstTime 时自动认为已经渲染完成
                firstCardFinishLoad.value = true;
            }, MaxRenderTimeForFirstTime);

            const webLogger = getKwaiLog();
            try {
                webLogger?.plugins?.radar?.fmp(fmp_time);
            } catch (error) {
                console.error(error);
            }

            beginTime.value = new Date().getTime();
            expandwords.value = expandwordsRef.value?.showThis;
            setTimeout(() => {
                sendPv();
            }, 0);

            // 刷新页面后放置重复注册
            proxy.$bus.off('setMuted');
            proxy.$bus.off('changeLoginPopupShow');
            proxy.$bus.off('copyToClipboard');
            proxy.$bus.off('follow');
            proxy.$bus.off('jumpProfile');
            proxy.$bus.off('scrollAutoPlayVideos');

            proxy.$bus.on('setMuted', setMuted);
            proxy.$bus.on('changeLoginPopupShow', changeLoginPopupShow);
            proxy.$bus.on('copyToClipboard', copyToClipboard);
            proxy.$bus.on('follow', follow);
            proxy.$bus.on('jumpProfile', jumpProfile);
            proxy.$bus.on('scrollAutoPlayVideos', scrollAutoPlayVideos);

            window.addEventListener('beforeunload', consume_duration);
        });

        let isPageNotActive = true;
        const handleVisibilityChange = () => {
            const lastPlayVideoEle = window.lastPlayVideoEle;
            if (document.hidden && isPageNotActive) {
                isPageNotActive = false;
                // console.log("页面被隐藏了");
                lastPlayVideoEle.pause();
            } else {
                isPageNotActive = true;
                setTimeout(() => {
                    lastPlayVideoEle.play();
                }, 500);
            }
        };

        onActivated(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            document.addEventListener('visibilitychange', handleVisibilityChange);

            if (!newDiscoverList.value.length) {
                initNewData();
            }
            scrollAutoPlayVideos();
        });

        onDeactivated(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        });

        // gpt
        function copyToClipboard(str: string) {
            // 创建一个临时的输入元素，设置其值为网页链接
            const tempInput = document.createElement('input');
            tempInput.value = str;
            document.body.appendChild(tempInput);

            // 选中该输入元素的文本内容，并执行复制到剪切板的操作
            tempInput.select();
            document.execCommand('copy');

            // 将该输入元素从文档中移除
            document.body.removeChild(tempInput);

            // 如果想要给出复制成功或失败的提示，可以使用以下代码：
            document.execCommand('copy');

            Toast({
                message: proxy.$root.$t('k_446636'),
            });
        }

        onUnmounted(() => {
            observer.disconnect();
        });

        return {
            muted,
            isShowLoginPopup,
            isLoginStatus,
            newDiscoverList,
            // lastPlayVideoEle,
            copyToClipboard,
            handleLoginPopupClose,
            changeLoginStatus,
            changeLoginPopupShow,
            handleLoginPopupOpenkwai,
            handleSearch,
            handleFirstCardFinishRender,
            videoCategoryCardListRef,
            dynamicCompRef,
            searchBarRef,
            firstCardFinishLoad,
            expandwordsRef,
            expandwords,
        };
    },
});
